module.exports = __webpack_public_path__ + "static/media/SalesReturn.bb68ee19.png";